import { Flex, Heading, Text, FlexProps } from '@chakra-ui/react';
import { colors } from 'theme/colors';
import React, { memo } from 'react';
import { CustomIcon } from 'components';
import { IIcon } from 'components/Icon/icons';

export interface IAvailableConclusions extends FlexProps {
  type: 'approve' | 'warning' | 'error';
}

const ConclusionMessageComponent: React.FC<IAvailableConclusions> = ({ type, ...props }) => {
  interface ItemPropsValue {
    color?: IIcon['$iconColor'];
    title: String;
    text: String;
  }

  interface ItemProps {
    [key: string]: ItemPropsValue;
  }

  const types: ItemProps = {
    approve: {
      color: 2100,
      title: 'Risco Baixo',
      text: 'PROSSEGUIR COM O PROJETO, APÓS VERIFICAR AS DEMAIS RECOMENDAÇÕES ABAIXO',
    },
    warning: {
      color: 2200,
      title: 'Risco Moderado',
      text: 'SUBMETER AO ANALISTA DE PRIVACIDADE (GOVERNANÇA)',
    },
    error: {
      color: 'red200',
      title: 'Risco Alto',
      text: 'Submeter ao encarregado/equipe de privacidade',
    },
  };

  return (
    <Flex
      borderRadius="4px"
      border="2px solid"
      borderColor="brand.red200"
      p="16px"
      {...props}
      flexDirection="column"
    >
      <Heading as="h4" fontSize="14px">
        <Flex>
          <Heading color="brand.red200">
            <CustomIcon icon="info_outline" size="20px" color="brand.red200" $noSphere />
          </Heading>
          <Text
            color={colors.brand[types[type].color || 400]}
            mt="auto"
            mb="auto"
            fontStyle="normal !important"
            ml="10px"
            fontSize="14px"
          >
            {types[type].title}
          </Text>
        </Flex>
      </Heading>
      <Text fontStyle="normal !important" fontSize="14px" color={colors.brand[900]} mt="11px">
        {types[type].text}
      </Text>
    </Flex>
  );
};

export const ConclusionMessage = memo(ConclusionMessageComponent);
